export const EMPLOYEELOCATION_LOADING = "EMPLOYEELOCATION_LOADING";
export const EMPLOYEELOCATION_RESET = "EMPLOYEELOCATION_RESET";
export const GET_EMPLOYEELOCATION = "GET_EMPLOYEELOCATION";
export const GET_EMPLOYEELOCATION_SUCCESS = "GET_EMPLOYEELOCATION_SUCCESS";
export const GET_EMPLOYEELOCATION_FAIL = "GET_EMPLOYEELOCATION_FAIL";
export const DELETE_EMPLOYEELOCATION = "DELETE_EMPLOYEELOCATION"
export const DELETE_EMPLOYEELOCATION_SUCCESS = "DELETE_EMPLOYEELOCATION_SUCCESS"
export const DELETE_EMPLOYEELOCATION_FAIL = "DELETE_EMPLOYEELOCATION_FAIL"
export const UPDATE_EMPLOYEELOCATION = "UPDATE_EMPLOYEELOCATION"
export const UPDATE_EMPLOYEELOCATION_SUCCESS = "UPDATE_EMPLOYEELOCATION_SUCCESS"
export const UPDATE_EMPLOYEELOCATION_FAIL = "UPDATE_EMPLOYEELOCATION_FAIL"
export const ADD_NEW_EMPLOYEELOCATION = "ADD_NEW_EMPLOYEELOCATION"
export const ADD_EMPLOYEELOCATION_SUCCESS = "ADD_EMPLOYEELOCATION_SUCCESS"
export const ADD_EMPLOYEELOCATION_FAIL = "ADD_EMPLOYEELOCATION_FAIL"